import { useMutation } from "@tanstack/react-query";
import { createTicketOnIntercom } from "../../apis/intercom";

export const useCreateTicketOnIntercom = ()=>{

    return useMutation({
        mutationFn: createTicketOnIntercom
    })
};